if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('.product-form__submit');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';

      const formData = new FormData(this.form)

      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      }
      formData.append('sections_url', window.location.pathname);

      let newFormData = new FormData()
      for (let entry of formData.entries()) {
        if (!entry[1] || entry[1].length === 0) {
          continue
        }
        newFormData.append(entry[0], entry[1])
      }

      var addData = {};
      newFormData.forEach(function(value, key){
          addData[key] = value;
      });

      addData.items = [
        {
          id: addData.id,
          quantity: addData.quantity,
          properties: {}
        }
      ]

      let extraItems = this.form.querySelectorAll('[data-extra-product]')

      for (let extraItemElem of extraItems) {
        if (extraItemElem.checked) {
          addData.items.push({
            id: extraItemElem.dataset.extraProduct,
            quantity: 1
          })
        }
      }

      for (let key of Object.keys(addData)) {
        console.log(key)
        if (key.includes('properties[')) {
          addData.items[0].properties[key.match(/^properties\[(.+)\]$/)[1]] = addData[key]
          delete addData[key]
        }
      }

      delete addData.id
      delete addData.quantity

      config.body = JSON.stringify(addData)

      console.log(addData)

      fetch(`/cart/add.js`, config)
        .then((response) => response.json())
        .then((response) => {
          // engrave customization
              console.log(document.querySelectorAll('.product-engrave .required').length);
          if (!document.querySelectorAll('.product-engrave .required').length) {
            setTimeout(function() {
              document.querySelectorAll('.product-engrave select').forEach(function(select) {
                select.selectedIndex = 0;

                var event = new Event('change', {
                  bubbles: true,
                  cancelable: true
                });
                select.dispatchEvent(event);
              });
              document.querySelectorAll('.product-engrave input').forEach(function(input) {
                input.value = ''; // Input değerini boş yap
              });
              
              var engravingSelect = document.getElementById('engraving_select');
              if (engravingSelect) {
                var event = new Event('change', {
                  bubbles: true,
                  cancelable: true
                });
                engravingSelect.dispatchEvent(event);
                engravingSelect.classList.remove('required');
              }
            });
          }
          
          if (response.status) {
            
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          for (let item of response.items) {
            let matching = addData.items.find(it => `${it.id}` === `${item.variant_id}`)
            if(matching) {
              window.__Theme._ctx.emit('cart-item-added', {
                lastItemAdded: {
                  item: item,
                  quantity: matching.quantity,
                }
              })
            }
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.cartNotification) {
              this.cartNotification.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.custom-product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
